import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardContent,
  Container,
} from "@mui/material";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import { Button, Card } from "react-bootstrap";
import "./OrderList.css";
import { Link, useNavigate } from "react-router-dom";
const styles = {
  button: {
    backgroundColor: "white",
    color: "grey",
  },
};

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    orderList();
  }, []);

  const orderList = async () => {
    try {
      const res = await axios.get(`http://api.meddaily.in/my_order`, {
        headers: {
          token: sessionStorage.getItem("token"),
        },
      });
      if (res.status === 200) {
        console.log(res.data.data);
        setOrders(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} sm={9}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Navbar />
            </Grid>
            <Grid item xs={11}>
              <Typography
                variant="h4"
                gutterBottom
                align="center"
                sx={{ marginTop: "15px" }}
              >
                Order Details
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Card style={{ marginTop: "24px", backgroundColor: "#ffffff" }}>
                <CardContent>
                  <Container maxWidth="lg">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Order ID</TableCell>
                          <TableCell>Product</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>TOTAL PRICE</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orders &&
                          orders.length > 0 &&
                          orders.map((order) => (
                            <TableRow key={order._id}>
                              <TableCell>{order.order_id}</TableCell>
                              <TableCell>
                                {order?.products[0]?.name || "NA"}
                              </TableCell>
                              <TableCell>
                                {order?.products[0]?.quantity || "NA"}
                              </TableCell>
                              <TableCell>{order.price}</TableCell>
                              <TableCell>
                                {order.order_status === 0 && "Cancelled"}
                                {order.order_status === 1 && "Order Shipped"}
                                {order.order_status === 3 && "Order Delivered"}
                                {order.order_status === 4 && "Order Placed"}
                              </TableCell>
                              <TableCell>
                                <button
                                  className="view-details-button"
                                  onClick={() =>
                                    navigate("/orderdetails", {
                                      state: { id: order.order_id },
                                    })
                                  }
                                >
                                  View Details
                                </button>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </Container>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default OrderList;
